module.exports = __webpack_public_path__ + "static/media/background.c95a6ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutHero/background.png
// module id = 571
// module chunks = 0